import { render, staticRenderFns } from "./dashboard-people.vue?vue&type=template&id=ec4e5c62&scoped=true&"
import script from "./dashboard-people.vue?vue&type=script&lang=js&"
export * from "./dashboard-people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4e5c62",
  null
  
)

export default component.exports